import { useQuery } from "@apollo/client";
import { Center, SimpleGrid, Tag } from "@chakra-ui/react";
import { useState } from "react";
import { ICollection } from "../../services/graphql/Collection";
import { COLLECTIONS } from "../../services/graphql/query/Collection";
import { CardCollections } from "../CardCollection/CardCollection";
import { ProductSkeletonLoading } from "../ProductSkeletonLoading/ProductSkeletonLoading";

export const Collections = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [dataCollections, setDataCollections] = useState<ICollection[]>([]);
  useQuery(COLLECTIONS, {
    onCompleted: (data) => {
      const { collections } = data;
      setDataCollections(collections);
      setLoading(false);
    },
    onError: (error) => {
      setLoading(false);
    },
  });

  return (
    <>
      {loading ? (
        <SimpleGrid minChildWidth="200px" spacing="40px">
          <ProductSkeletonLoading />
        </SimpleGrid>
      ) : dataCollections?.length ? (
        <SimpleGrid minChildWidth="200px" spacing="40px">
          {dataCollections.map((collection: ICollection) => (
            <CardCollections dataCollection={collection} />
          ))}
        </SimpleGrid>
      ) : (
        <Center>
          <Tag>NO SE ENCONTRARON COLECCIONES &#128532;</Tag>
        </Center>
      )}
    </>
  );
};
